/* eslint-disable no-console */
import M from 'materialize-css/dist/js/materialize';
import * as actionPicking from '../actions/pickingAction';
import HttpService from './HttpService';
import { getUrlExpeditionApi, isNullOrEmpty, objPagination, showMessageToastCustom, translate, language } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import * as actionGroup from '../actions/orderGroupAction';
import { ENUMS, PERMISSIONS } from '../utils/constants';
import { parseParams, getUrlRepositoryApi } from '../utils/util';
import Dao from '../dao/Dao';
import ConnectionFactory from '../dao/ConnectionFactory';
import { getVision, checkPermission, getUser } from './auth';

const httpService = new HttpService(getUrlExpeditionApi(window));
export default class PickingService {
    static getMissions(orderId) {
        const url = `/api/picking/orders/${orderId}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'orders'))
                            .then((ordersTable) => ordersTable.find(orderId)
                                .then((order) => {
                                    if (!isNullOrEmpty(order)) {
                                        order.items = response.data.data.items;
                                        order.dataStatus = 'R';
                                        order.items.map((mission) => {
                                            mission.dataStatus = 'R';
                                            return mission;
                                        });

                                        ordersTable.update(order);
                                        dispatch(actionPicking.listMission(order.items));
                                    }

                                    dispatch(actionPicking.listMission(response.data.data.items));
                                }));
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'orders'))
                    .then((ordersTable) => ordersTable.find(orderId))
                    .then((order) => {
                        let orderItems = [];
                        if (!isNullOrEmpty(order)) {
                            orderItems = order.items;
                        }
                        dispatch(actionPicking.listMission(orderItems));
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getSuppliers(vision, filter) {
        const url = '/api/picking/orders/suppliers';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter, paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'suppliers'))
                            .then((suppliersTable) => {
                                const dados = response.data;
                                if (dados && dados.data?.items) {
                                    dados.data.items.forEach((data) => {
                                        data.dataStatus = 'R';
                                        data.vision = vision;
                                        suppliersTable.add(data);
                                    });

                                    dispatch(actionPicking.setSuppliers(dados.data));
                                }
                            });
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'suppliers'))
                    .then((suppliersTable) => suppliersTable.getAll('vision', vision))
                    .then((suppliers) => {
                        const data = { items: suppliers };
                        dispatch(actionPicking.setSuppliers(data));
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getParts(vision, pagination) {
        const url = '/api/picking/orders/parts';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: pagination }).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'parts'))
                            .then((partsTable) => {
                                const dados = response.data;
                                if (dados && dados.data?.items) {
                                    dados.data.items.forEach((data) => {
                                        data.dataStatus = 'R';
                                        data.vision = vision;
                                        partsTable.add(data);
                                    });

                                    dispatch(actionPicking.setParts(dados.data));
                                }
                            });
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'parts'))
                    .then((partsTable) => partsTable.getAll('vision', vision))
                    .then((parts) => {
                        const data = { items: parts };
                        dispatch(actionPicking.setParts(data));
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getOrders(filter, pagination, callback) {
        Object.assign(filter, pagination);

        const url = '/api/picking/orders';
        const vision = getVision();
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter, paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'orders'))
                            .then((ordersTable) => {
                                const dados = response.data.data;
                                if (dados && dados.items) {
                                    dados.items.forEach((data) => {
                                        data.dataStatus = 'R';
                                        data.vision = vision;
                                        ordersTable.add(data);
                                    });
                                }
                                dispatch(actionPicking.setOrders(dados));
                            });
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'orders'))
                    .then((ordersTable) => ordersTable.search((o) => (o.status === ENUMS.eOrderStatus.Waiting.value || o.status === ENUMS.eOrderStatus.InProgress.value), 'vision', vision))
                    .then((orders) => {
                        if (filter) {
                            orders = orders.filter((o) => {
                                if (isNullOrEmpty(filter.cim) === false) {
                                    return o.cim === filter.cim;
                                } else if (isNullOrEmpty(filter.orderCode) === false) {
                                    return o.orderCode === filter.orderCode;
                                } else if (isNullOrEmpty(filter.partnumber) === false) {
                                    return o.partnumber === filter.partnumber;
                                } else if (isNullOrEmpty(filter.supplierCode) === false) {
                                    return o.supplierCode === filter.supplierCode;
                                } else {
                                    return o;
                                }
                            });
                        }

                        if (orders) {
                            // eslint-disable-next-line radix
                            const ordersPage = objPagination(orders);
                            dispatch(actionPicking.setOrders(ordersPage));
                        }
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getOrder(orderId, callback) {
        const url = `/api/picking/orders/${orderId}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'orders'))
                            .then((ordersTable) => {
                                const dados = [response.data.data];
                                const ordersPage = objPagination(dados);

                                ordersPage.items.forEach((data) => {
                                    if (data) {
                                        data.dataStatus = 'R';
                                        data.vision = getVision();
                                        ordersTable.add(data);
                                    }
                                });

                                dispatch(actionPicking.resetOrder());
                                dispatch(actionPicking.resetOrders());
                                dispatch(actionPicking.setOrders(ordersPage));
                                dispatch(actionPicking.selectOrder(ordersPage.items[0]));
                                if (callback) {
                                    callback(ordersPage.items[0]);
                                }
                            });
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'orders'))
                    .then((ordersTable) => ordersTable.search((o) => (o.status === ENUMS.eOrderStatus.Waiting.value || o.status === ENUMS.eOrderStatus.InProgress), 'vision', getVision()))
                    .then((orders) => {
                        if (orders && orders.length > 0) {
                            const dados = [orders[0]];
                            const ordersPage = objPagination(dados);

                            dispatch(actionPicking.resetOrder());
                            dispatch(actionPicking.resetOrders());
                            dispatch(actionPicking.setOrders(ordersPage));
                            dispatch(actionPicking.selectOrder(ordersPage.items[0]));
                            dispatch(endLoading());
                        }
                    });
            }
        };
    }

    static firstOrder(filter, callback) {
        const url = '/api/picking/orders/first';

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'orders'))
                            .then((ordersTable) => {
                                if (response.data.data) {
                                    const dados = [response.data.data];
                                    const ordersPage = objPagination(dados);

                                    ordersPage.items.forEach((data) => {
                                        if (data) {
                                            data.dataStatus = 'R';
                                            data.vision = getVision();
                                            ordersTable.add(data);
                                        }
                                    });

                                    dispatch(actionPicking.resetOrder());
                                    dispatch(actionPicking.resetOrders());
                                    dispatch(actionPicking.setOrders(ordersPage));
                                    dispatch(actionPicking.selectOrder(ordersPage.items[0]));

                                    if (callback) {
                                        callback(ordersPage.items[0]);
                                    }
                                }
                            });
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'orders'))
                    .then((ordersTable) => ordersTable
                        .search((ot) => ot.status === ENUMS.eOrderStatus.InProgress.value, 'vision', getVision()))
                    .then((orders) => {
                        dispatch(actionPicking.resetOrder());
                        dispatch(actionPicking.resetOrders());
                        if (orders && orders.length > 0) {
                            const ordersPage = objPagination(orders);

                            if (ordersPage.items.length > 0) {
                                dispatch(actionPicking.setOrders(ordersPage));
                                dispatch(actionPicking.selectOrder(ordersPage.items[0]));
                                if (callback) {
                                    callback(ordersPage.items[0]);
                                }
                            }
                        }
                        dispatch(endLoading());
                    });
            }
        };
    }

    static lastOrder(filter) {
        const url = '/api/picking/orders/last';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'orders'))
                            .then((ordersTable) => {
                                const dados = [response.data.data];
                                const orders = objPagination(dados);

                                orders.items.forEach((data) => {
                                    data.dataStatus = 'R';
                                    data.vision = getVision();
                                    ordersTable.add(data);
                                });

                                dispatch(actionPicking.resetOrder());
                                dispatch(actionPicking.resetOrders());
                                dispatch(actionPicking.setOrders(orders));
                                dispatch(actionPicking.selectOrder(orders.items[0]));
                            });
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'orders'))
                    .then((ordersTable) => ordersTable.search((o) =>
                        o.status === ENUMS.eOrderStatus.InProgress.value, 'vision', getVision()))
                    .then((orders) => {
                        if (orders && orders.length > 0) {
                            const ordersPage = objPagination(orders);

                            dispatch(actionPicking.resetOrder());
                            dispatch(actionPicking.resetOrders());
                            if (ordersPage.items.length > 0) {
                                dispatch(actionPicking.setOrders(ordersPage));
                                dispatch(actionPicking.selectOrder(ordersPage.items[0]));
                                dispatch(endLoading());
                            }
                        }
                    });
            }
        };
    }

    static startOrder(orderId, callback) {
        const url = `/api/picking/orders/${orderId}/start`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'orders'))
                            .then((ordersTable) => ordersTable.search((ot) => ot.orderId === orderId, 'vision', getVision())
                                .then((orders) => {
                                    if (!isNullOrEmpty(orders) && orders[0]) {
                                        orders[0].status = ENUMS.eOrderStatus.InProgress.value;
                                        orders[0].dataStatus = 'R';
                                    }
                                    ordersTable.update(orders[0]);
                                }));
                        dispatch(actionPicking.updateOrderStatus(orderId, ENUMS.eOrderStatus.InProgress.value));
                        if (callback) callback();
                    } else {
                        M.toast({ html: response?.data?.message, classes: 'red' });
                    }
                }).catch((error) => {
                    M.toast({ html: error.response?.data?.message || error.message, classes: 'red' });
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static unblockOrder(orderId, callback) {
        const url = `/api/picking/orders/${orderId}/unblock`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'orders'))
                            .then((ordersTable) => ordersTable.search((o) => o.orderId === orderId, 'vision', getVision())
                                .then((orders) => {
                                    if (!isNullOrEmpty(orders) && orders[0]) {
                                        orders[0].status = ENUMS.eOrderStatus.Waiting.value;
                                        orders[0].dataStatus = 'U';
                                    }
                                    ordersTable.update(orders[0]);
                                }));
                        dispatch(actionPicking.unblockOrder(orderId));
                        if (callback) callback();
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    M.toast({ html: error.response?.data?.message || error.message, classes: 'red' });
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static changeStatusOrder(orderId, status, callback) {
        const url = '/api/Picking/order/changestatus';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, status }).then((response) => {
                    if (response.status === 200) {
                        if (callback) callback();
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    M.toast({ html: error.response?.data?.message || error.message, classes: 'red' });
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static printOrders(data, callback) {
        const url = '/api/Picking/print';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, data).then((response) => {
                    if (response.status === 200) {
                        if (response.data.data && response.data.data.length > 0) {
                            this.printLabel(response.data.data, data.printer)
                        }
                        if (callback) callback();
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static printLabelIdentification(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/picking/label/identification`;
                httpService.instance.post(url, filter,
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response) {
                            var data = response.data?.data
                            if (data && data.length > 0) {
                                let arrayLabel = [];
                                data.forEach(label => {
                                    arrayLabel.push({ dataToPrint: label })
                                });

                                this.printLabel(arrayLabel, filter.printer);
                            }
                            callback(data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static printLabel(labels, print) {
        if (print.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
            if (navigator.userAgent === 'logisticspwa' && labels.length > 0) {
                const sendToPrinter = {
                    messageType: 'printArray',
                    printerManufacturer: print.printerManufacture || ENUMS.ePrinterManufacturerPortable.Honeywell.value,
                    array: labels,
                    printerAddress: print.macAddress,
                    lng: language()
                };

                window.ReactNativeWebView.postMessage(JSON.stringify(sendToPrinter));
            } else {
                showMessageToastCustom(translate('warning', 'general'), 'Impressão não pode ser realizada', 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        }
    }

    static changeUserOrder(orderId, newUser, callback) {
        const url = '/api/picking/orders/changeuser';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, newUser }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionPicking.changeUserOrder(orderId, newUser));
                        if (callback) callback();
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    M.toast({ html: error.response?.data?.message || error.message, classes: 'red' });
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static startOrderItem(orderId, orderItemId, callback) {
        const url = '/api/picking/mission/start';
        const vision = getVision();
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, orderItemId }).then((response) => {
                    if (response.status === 200) {
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'orders'))
                            .then((ordersTable) => ordersTable.search((o) => o.orderId === orderId, 'vision', vision)
                                .then((orders) => {
                                    if (!isNullOrEmpty(orders) && orders[0].items) {
                                        const item = orders[0].items.find((i) => i.orderItemId === orderItemId);
                                        item.status = ENUMS.eOrderItemStatus.InProgress.value;
                                        item.dataStatus = 'U';
                                        orders[0].dataStatus = 'U';
                                    }
                                    ordersTable.update(orders[0]);
                                }));

                        dispatch(actionPicking.updateMissionStatus(orderItemId, ENUMS.eOrderItemStatus.InProgress.value));
                        if (callback) callback();
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    M.toast({ html: error.response?.data?.message || error.message, classes: 'red' });
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'orders'))
                    .then((ordersTable) => ordersTable.search((o) => o.orderId === orderId, 'vision', vision)
                        .then((orders) => {
                            if (orders && orders[0].items) {
                                const item = orders[0].items.find((i) => i.orderItemId === orderItemId);
                                item.status = ENUMS.eOrderItemStatus.InProgress.value;
                                orders[0].dataStatus = 'U';
                                item.dataStatus = 'U';
                                dispatch(actionPicking.updateMissionStatus(orderItemId, ENUMS.eOrderItemStatus.InProgress.value));
                                ordersTable.update(orders[0]);
                                dispatch(endLoading());
                                if (callback) callback();
                            }
                        }));
            }
        };
    }

    static unblockMission(mission, callback) {
        const url = '/api/picking/mission/reset';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId: mission.orderId, orderItemId: mission.orderItemId }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionPicking.unblockOrderItem(mission.orderId, mission.orderItemId));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    console.log('error on start orderItem', error);
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(actionPicking.unblockOrderItem(mission.orderId, mission.orderItemId));
                if (callback) {
                    callback();
                }
            }
        };
    }

    static confirmPicking(orderItem, callback) {
        const url = '/api/picking';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId: orderItem.orderId, orderItemId: orderItem.orderItemId }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionPicking.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.WaitingFinish.value));

                        // Remover caso seja atraves de sincronismo para que faça mais de uma vez.
                        ConnectionFactory
                            .getConnection()
                            .then((connection) => new Dao(connection, 'picking'))
                            .then((pickingTable) => {
                                pickingTable.find(orderItem.orderItemId).then((item) => {
                                    if (!isNullOrEmpty(item)) {
                                        pickingTable.remove(orderItem.orderItemId);
                                    }
                                });
                            });

                        if (callback) callback(response)
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    M.toast({ html: error.response?.data?.message || error.message, classes: 'red' });
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'picking'))
                    .then((dao) => {
                        dao.find(orderItem.orderItemId).then((item) => {
                            if (isNullOrEmpty(item)) {
                                // eslint-disable-next-line max-len
                                item = { dataStatus: 'I', orderItemId: orderItem.orderItemId, orderId: orderItem.orderId, dtFinished: new Date().toString(), vision: getVision() };
                                dao.add(item);

                                ConnectionFactory
                                    .getConnection()
                                    .then((connectionOrders) => new Dao(connectionOrders, 'orders'))
                                    .then((daoOrders) => daoOrders.find(orderItem.orderId)
                                        .then((order) => {
                                            if (!isNullOrEmpty(order)) {
                                                const itemOrder = order.items.find((o) => o.orderItemId === orderItem.orderItemId);
                                                if (!isNullOrEmpty(itemOrder)) {
                                                    itemOrder.dataStatus = 'U';
                                                    itemOrder.status = ENUMS.eOrderItemStatus.WaitingFinish.value;
                                                    daoOrders.update(order);
                                                }
                                            }
                                            // eslint-disable-next-line max-len
                                            dispatch(actionPicking.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.WaitingFinish.value));
                                            dispatch(endLoading());
                                        }));
                            }
                        });
                    });
            }
        };
    }

    static rePicking(orderItem, callback) {
        const url = '/api/picking/repicking';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url,
                    { orderId: orderItem.orderId, orderItemId: orderItem.orderItemId, justificationId: orderItem.justificationId }).then((response) => {
                        if (response.status === 200) {
                            dispatch(actionPicking.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.WaitingRepicking.value));
                            ConnectionFactory
                                .getConnection()
                                .then((connection) => new Dao(connection, 'repicking'))
                                .then((dao) => {
                                    dao.find(orderItem.orderItemId).then((item) => {
                                        if (!isNullOrEmpty(item)) {
                                            dao.remove(orderItem.orderItemId);
                                        }
                                        if (callback) {
                                            callback();
                                        }
                                    });
                                });
                        } else {
                            M.toast({ html: response.data.message, classes: 'red' });
                        }
                    }).catch((error) => {
                        M.toast({ html: error.response?.data?.message || error.message, classes: 'red' });
                        return error;
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            } else {
                ConnectionFactory
                    .getConnection()
                    .then((connection) => new Dao(connection, 'repicking'))
                    .then((dao) => {
                        dao.find(orderItem.orderItemId).then((item) => {
                            if (isNullOrEmpty(item)) {
                                // eslint-disable-next-line max-len
                                item = { dataStatus: 'I', orderItemId: orderItem.orderItemId, orderId: orderItem.orderId, dtFinished: new Date().toString(), vision: getVision() };
                                dao.add(item);

                                ConnectionFactory
                                    .getConnection()
                                    .then((connectionOrders) => new Dao(connectionOrders, 'orders'))
                                    .then((daoOrders) => daoOrders.find(orderItem.orderId)
                                        .then((order) => {
                                            if (!isNullOrEmpty(order)) {
                                                const itemOrder = order.items.find((o) => o.orderItemId === orderItem.orderItemId);
                                                if (!isNullOrEmpty(itemOrder)) {
                                                    itemOrder.dataStatus = 'U';

                                                    itemOrder.status = ENUMS.eOrderItemStatus.WaitingRepicking.value;

                                                    daoOrders.update(order);
                                                }
                                            }
                                            // eslint-disable-next-line max-len
                                            dispatch(actionPicking.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.WaitingRepicking.value));
                                            if (callback) {
                                                callback();
                                            }
                                            dispatch(endLoading());
                                        }));
                            }
                        });
                    });
            }
        };
    }

    static confirmRepickingFromServer(orderItem) {
        return (dispatch) => {
            try {
                ConnectionFactory
                    .getConnection()
                    .then((connectionOrders) => new Dao(connectionOrders, 'orders'))
                    .then((daoOrders) => daoOrders.find(orderItem.orderId)
                        .then((order) => {
                            if (!isNullOrEmpty(order)) {
                                const itemOrder = order.items.find((o) => o.orderItemId === orderItem.orderItemId);

                                if (isNullOrEmpty(orderItem.orderItemOriginId)) {
                                    dispatch(actionPicking.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.Canceled.value));
                                    if (!isNullOrEmpty(itemOrder)) {
                                        itemOrder.status = ENUMS.eOrderItemStatus.Canceled.value;
                                        itemOrder.dataStatus = 'R';
                                        daoOrders.update(order);

                                        const msg = translate('expedition.picking.repicking-task-canceled').replace('[orderItemCode]', orderItem.location).replace('[orderCode]', order.orderCode);

                                        showMessageToastCustom(translate('warning', 'general'), msg, 8000, 'mdi mdi-information-outline blue-text');
                                    }
                                } else {
                                    dispatch(actionPicking.updateMissionStatus(orderItem.orderItemOriginId, ENUMS.eOrderItemStatus.Repicking.value));
                                    dispatch(actionPicking.addOrderItem(orderItem));

                                    Object.assign(itemOrder, orderItem);
                                    itemOrder.dataStatus = 'R';
                                    order.items.push(itemOrder);

                                    const itemOrderOrigin = order.items.find((o) => o.orderItemId === orderItem.orderItemOriginId);
                                    if (!isNullOrEmpty(itemOrderOrigin)) {
                                        itemOrderOrigin.status = ENUMS.eOrderItemStatus.Repicking.value;
                                        itemOrderOrigin.dataStatus = 'R';
                                    }

                                    daoOrders.update(order);

                                    const msg = translate('expedition.picking.repicking-task-received').replace('[orderCode]', order.orderCode);

                                    showMessageToastCustom(translate('warning', 'general'), msg, 8000, 'mdi mdi-information-outline blue-text');
                                }
                            }

                            const event = new CustomEvent('expeditionRefreshListOrderItems');
                            document.dispatchEvent(event);
                        }));
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static confirmPickingFromServer(orderItem) {
        return (dispatch) => {
            try {
                if (orderItem) {
                    ConnectionFactory
                        .getConnection()
                        .then((connectionOrders) => new Dao(connectionOrders, 'orders'))
                        .then((daoOrders) => daoOrders.find(orderItem.orderId)
                            .then((order) => {
                                if (!isNullOrEmpty(order)) {
                                    const itemOrder = order.items.find((o) => o.orderItemId === orderItem.orderItemId);
                                    if (!isNullOrEmpty(itemOrder) && itemOrder !== undefined) {
                                        itemOrder.dataStatus = 'R';

                                        itemOrder.status = ENUMS.eOrderItemStatus.Finished.value;
                                    }
                                    daoOrders.update(order);
                                }
                            }));
                    dispatch(actionPicking.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.Finished.value));
                    const event = new CustomEvent('expeditionRefreshListOrderItems');
                    document.dispatchEvent(event);
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static updateOrderFromServer(order) {
        return (dispatch) => {
            try {
                if (order) {
                    const manageOrder = checkPermission(PERMISSIONS.Expedition.Picking.ManageOrder);
                    const currentUser = getUser();
                    let removeOrder = false;
                    if (!manageOrder && order.startedBy !== currentUser.userName) {
                        removeOrder = true;
                    }

                    if (removeOrder === true) {
                        dispatch(actionPicking.removeOrder(order));
                    } else {
                        dispatch(actionPicking.updateOrder(order));
                    }
                    const event = new CustomEvent('expeditionRefreshListOrders', order);
                    document.dispatchEvent(event);
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static pickingSync = (vision) => {
        return (dispatch) => {
            ConnectionFactory
                .getConnection()
                .then((cnn) => new Dao(cnn, 'picking'))
                .then((pickingTable) => pickingTable.search((o) => o.dataStatus !== 'D', 'vision', vision))
                .then((pickingItems) => {
                    if (pickingItems) {
                        pickingItems.map((orderItem) => {
                            return ConnectionFactory
                                .getConnection()
                                .then((cnnOrders) => new Dao(cnnOrders, 'orders'))
                                .then((ordersTable) => ordersTable.search((o) => o.orderId === orderItem.orderId, 'vision', vision))
                                .then((orders) => {
                                    const item = orders.items.find((o) => o.orderId === orderItem.orderId
                                        && o.orderItemId === orderItem.orderItemId);
                                    dispatch(this.startOrderItem(item.orderId, item.orderItemId, () => {
                                        dispatch(this.confirmPicking(item));
                                    }));
                                });
                        });
                    }
                });
        };
    }

    static repickingSync = (vision) => {
        return (dispatch) => {
            ConnectionFactory
                .getConnection()
                .then((cnn) => new Dao(cnn, 'repicking'))
                .then((repickingTable) => repickingTable.search((o) => o.dataStatus !== 'D', 'vision', vision))
                .then((repickingItems) => {
                    if (repickingItems) {
                        repickingItems.map((orderItem) => {
                            return ConnectionFactory
                                .getConnection()
                                .then((cnnOrders) => new Dao(cnnOrders, 'orders'))
                                .then((ordersTable) => ordersTable.search((o) => o.orderId === orderItem.orderId, 'vision', vision))
                                .then((orders) => {
                                    const item = orders.items.find((o) => o.orderId === orderItem.orderId
                                        && o.orderItemId === orderItem.orderItemId);

                                    dispatch(this.startOrderItem(item.orderId, item.orderItemId, () => {
                                        dispatch(this.rePicking(item));
                                    }));
                                });
                        });
                    }
                });
        };
    }

    static getOrdersOpen(orderTypeFilter, callback) {
        const url = '/api/picking/orders/open';
        const filter = { orderType: orderTypeFilter };
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data.data) {
                        callback(response.data.data)
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getOrdersItemOpen(orderTypeFilter, callback) {
        const url = '/api/picking/orderitems/open';
        const filter = { orderType: orderTypeFilter };

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data.data) {
                        callback(response.data.data)
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getOrdersGroup(filter, callback) {
        const url = '/api/picking/orders/group';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200 && response.data.data) {
                        dispatch(actionGroup.setOrderGroups(response.data.data));
                        if (callback) {
                            callback(response.data.data)
                        }
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static live(callback) {
        const url = '/api/Live';
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    callback(response);
                }).catch((error) => {
                    callback(error);
                })
            }
        };
    }

    static endCalls(data, vision, callback) {
        const url = '/api/picking/endCallsOrder';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, data).then((response) => {
                    if (isNullOrEmpty(response.data.data)) {
                        showMessageToastCustom(translate('confirmed', 'general'), translate('line-picking:endCalls:message-success'), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        let result = [];
                        var keys = Object.keys(response.data.data);
                        keys.map((key) => result.push({ code: key, message: response.data.data[key] }))
                        if (callback) {
                            callback(result);
                        }
                    }
                }).catch((error) => {
                    console.log('error on start orderItem', error);
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static validateOrder(data, vision, callback) {
        const url = '/api/picking/validateOrder';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, data).then((response) => {
                    if (callback) callback(response.data);
                }).catch((error) => {
                    console.log('error on validate order', error);
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static confirmPickingByOrder(orderCode, callback) {
        const url = `/api/picking/byorder/${orderCode}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) callback(response)
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    M.toast({ html: error.response?.data?.message || error.message, classes: 'red' });
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static writeOffOrderList(filter, callback) {
        const url = `/api/picking/writeOff/massive`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, filter).then((response) => {
                    if (response.status === 200) {
                        if (callback) callback(response.data.data);
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }



    static writeOffOrder(orderCode, callback) {
        const url = `/api/picking/writeOff/${orderCode}/${ENUMS.eOrderType.LinePicking.value}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) callback(response)
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static InsertInvoice(file, key, callback) {
        const url = '/api/invoice/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);
                formData.append('InvoiceKey', key);
                httpService.instance.post(url, formData).then((response) => {
                    if (response.status === 200) {
                        showMessageToastCustom(translate('confirmed', 'general'), "Arquivo enviado com sucesso.", 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) {
                            callback()
                        }
                    }

                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static generateSpreadsheet(list, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/cimfile/generatespreadsheet`, list, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (response.status === 200 && response.data?.data) {
                            if (callback) callback(response.data.data);
                        }
                    }).catch((error) => {
                        dispatch(endLoading());
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            };
        }
    }


    static generateExpeditionCim(list, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/cimfile/expeditioncim`, list, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback();
                            }
                        }
                    }).catch((error) => {
                        dispatch(endLoading());
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            };
        }
    }

    static getCimFiles(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get('/api/cimfile', { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    dispatch(actionPicking.updateCimFile(response.data.data));
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    dispatch(endLoading());
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getInvoicesFile(filter, callback) {
        const url = '/api/invoice';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data.data) {
                        dispatch(actionPicking.SetInvoicesFile(response.data.data));
                        if (callback) {
                            callback(response.data.data)
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getInvoicesFileReport(filter, callback) {
        const url = '/api/invoice';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data.data) {
                        if (callback) {
                            callback(response.data.data)
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    dispatch(endLoading());
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getLogGcpPaged(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get('/api/gcp/LogGcp', { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    dispatch(actionPicking.updateLogs(response.data.data));
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    dispatch(endLoading());
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static forceResend(callback) {
        const url = '/api/gcp';
        return (dispatch) => {
            if (navigator.onLine) {
                //dispatch(startLoading());
                httpService.instance.patch(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status !== 200) {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), "Em processamento...", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getSpreadsheet(filename, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                let url = `${getUrlRepositoryApi(window)}/api/repository/download?path=expedition/cim/${filename}`;
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data && callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static generateCsv(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                const url = `/api/cimfile/generatecsv`;
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getReportTdCsv(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/picking/order/reporttdcsv`;
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200 && response.data?.data && callback) {
                            callback(response.data?.data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }
}
